import { render } from "./OrderFormCost.vue?vue&type=template&id=1f1b7a9a&scoped=true&ts=true"
import script from "./OrderFormCost.vue?vue&type=script&lang=ts"
export * from "./OrderFormCost.vue?vue&type=script&lang=ts"

import "./OrderFormCost.vue?vue&type=style&index=0&id=1f1b7a9a&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1b7a9a"]])

export default __exports__